export enum HeatInstallationIconEnum {
  Gas = 'gas.svg',
  Oil = 'oil.svg',
}
